import Loading from '../../../Common/Loading';
import { ByCity } from './ByCity';
import { ByNeighbourhood } from './ByNeighbourhood';
import { ByPoliceStation } from './ByPoliceStation';
import { BySectional } from './BySectional';
import { ByDepartment } from './ByDepartment';
import { useRankingsChartsDataContext } from './hooks/useRankingsChartsDataContext';

export const Charts = () => {
    const { isLoading } = useRankingsChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <ByPoliceStation />
                <ByDepartment />
            </div>
            <div className="charts-side-by-side-dashboards">
                <BySectional />
                <ByCity />
            </div>
            <div className="charts-side-by-side-dashboards">
                <ByNeighbourhood />
            </div>
        </>
    );
};
